import axios from "axios";
import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

import { useAuth } from "hooks/useAuth";

export default function RejectTQModal({
  show,
  handleClose,
  technicalQuery,
  refetch,
}) {
  const [rejection, setRejection] = useState("");
  const { authToken, csrfToken, currentUser } = useAuth();

  const handleDeleteTQ = () => {
    axios
      .put(
        `${import.meta.env.VITE_DJANGO_ENDPOINT}technical-query/${technicalQuery?.tq_id}/`,
        {
          status: "Rejected",
          response: rejection,
          response_by: currentUser.id,
          response_on: new Date(
            new Date().setMinutes(
              new Date().getMinutes() - new Date().getTimezoneOffset(),
            ),
          ),
          recaptcha_token: "member_portal",
          modified_on: new Date(
            new Date().setMinutes(
              new Date().getMinutes() - new Date().getTimezoneOffset(),
            ),
          ),
          send_email: true,
        },
        {
          withCredentials: true,
          headers: { Authorization: `Token ${authToken}` },
        },
      )
      .then((response) => {
        handleClose();
        refetch();
      })
      .catch((err) => console.log("unable to get technical query", err));
  };

  return (
    <Modal size="md" show={show} onHide={handleClose}>
      <Modal.Header closeButton className="border-0">
        <Modal.Title>
          Reject Technical Query - {technicalQuery?.title}?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Form.Label>
            <h4>Rationale for Rejection</h4>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={6}
            name="response"
            onChange={(e) => setRejection(e.target.value)}
            required
          />
        </div>
        <div className="d-flex justify-content-center mt-4">
          <Button
            variant="outline-primary"
            className="m-1"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            id={"reject-tq-button"}
            variant="danger"
            className="m-1"
            disabled={rejection === ""}
            onClick={handleDeleteTQ}
          >
            Reject
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
